import React from 'react';
import { I18n } from '@fiverr-private/fiverr_context';
import { Section } from '@fiverr-private/fit';
import './index.scss';

const Footer = () => {

    const FOOTER_ITEMS = [
        'first_box',
        'second_box',
        'third_box'
    ];

    return (
        <footer>
            <Section className="footer-wrapper" equalPadding>
                {FOOTER_ITEMS.map((item) => (
                    <span className="footer-item" key={item}>
                        <h3><I18n k={`category_page.footer.${item}.title`}/> <b><I18n k={`category_page.footer.${item}.title_bold`}/></b></h3>
                        <I18n k={`category_page.footer.${item}.text`}/>
                    </span>
                ))}
            </Section>
        </footer>
    );
};

export default Footer;
